<template>
  <div v-if="loading">Loading...</div>
  <div v-else-if="error">{{ error }}</div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      error: null,
    };
  },
  created() {
    this.handleCallback();
  },
  methods: {
    handleCallback() {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code");
      const state = urlParams.get("state");
      const session_state = urlParams.get("session_state");

      if (!code || !state) {
        this.error = "Missing code or state";
        this.loading = false;
        this.$router.push(`/login?error=${encodeURIComponent(this.error)}`);
        return;
      }

      // Redirect to login with query parameters
      this.$router.push({
        path: '/login',
        query: {
          code,
          state,
          session_state: session_state || '',
        },
      });

      // Clean up state
      localStorage.removeItem("safenet_state");
    },
  },
};
</script>